import React, { useState } from 'react'
import Loading from './Loading'
import Chart from './Chart'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import useData from '../hooks/useData'
import { format, subDays } from 'date-fns'

const byDate = (a, b) => {
    return !a.keys[1].localeCompare(b.keys[1])
}

const SearchConsole = (props) => {
    const id = props.id || (props.match && props.match.params && props.match.params.id) || false
    const [date, setDate] = useState([subDays(new Date(), 30), new Date()])
    let { isLoading: isLoadingArticle, data: article } = useData('article/' + id)
    let { isLoading: isLoadingSite, data: site } = useData((article && 'site/' + article.site_id) || null)
    // const url_page = 'https://www.sac-de-metier.com/sacs-et-cartables-professeur/'
    const { isLoading: isLoadingCurrent, data: current_data } = useData(
        article &&
            site &&
            'google/search_console?dimensions[0]=page&dimensions[1]=date&site_id=' +
                article.site_id +
                '&url=' +
                'https://' +
                site.url +
                '/' +
                ((article.permalink !== 'homepage' && article.permalink) || '') +
                '&start_date=' +
                format(date[0], 'yyyy-MM-dd') +
                '&end_date=' +
                format(date[1], 'yyyy-MM-dd'),
        (r) => (r && r.filter((i) => i.position < 30)) || null
    )
    const { isLoading: isLoadingCurrentAmp, data: current_data_amp } = useData(
        article &&
            site &&
            'google/search_console?dimensions[0]=page&dimensions[1]=date&site_id=' +
                article.site_id +
                '&url=' +
                'https://' +
                site.url +
                '/' +
                ((article.permalink !== 'homepage' && article.permalink) || '') +
                encodeURI('?amp=1') +
                '&start_date=' +
                format(date[0], 'yyyy-MM-dd') +
                '&end_date=' +
                format(date[1], 'yyyy-MM-dd'),
        (r) => (r && r.filter((i) => i.position < 30)) || null
    )
    const { isLoading: isLoadingOld, data: old_data } = useData(
        article &&
            article.old_permalink &&
            site &&
            'google/search_console?dimensions[0]=page&dimensions[1]=date&site_id=' +
                article.site_id +
                '&url=' +
                'https://' +
                site.url +
                '/' +
                article.old_permalink +
                '&start_date=' +
                format(date[0], 'yyyy-MM-dd') +
                '&end_date=' +
                format(date[1], 'yyyy-MM-dd'),
        (r) => (r && r.filter((i) => i.position < 30)) || null
    )
    const { isLoading: isLoadingOldAmp, data: old_data_amp } = useData(
        article &&
            article.old_permalink &&
            site &&
            'google/search_console?dimensions[0]=page&dimensions[1]=date&site_id=' +
                article.site_id +
                '&url=' +
                'https://' +
                site.url +
                '/' +
                article.old_permalink +
                encodeURI('?amp') +
                '&start_date=' +
                format(date[0], 'yyyy-MM-dd') +
                '&end_date=' +
                format(date[1], 'yyyy-MM-dd'),
        (r) => (r && r.filter((i) => i.position < 30)) || null
    )
    const data = (current_data && [...current_data, ...(current_data_amp || []), ...(old_data || []), ...(old_data_amp || [])]) || []

    // console.log({data}, isLoadingCurrent, isLoadingCurrentAmp, isLoadingOld, isLoadingOldAmp)

    return (
        <React.Fragment>
            {(isLoadingArticle && <Loading text="Fetching article data" />) || null}
            {(isLoadingSite && <Loading text="Fetching site data" />) || null}
            {((isLoadingCurrent || isLoadingCurrentAmp || isLoadingOld || isLoadingOldAmp) && (
                <Loading text="Fetching data from Google Search Console API" />
            )) ||
                null}
            {(!isLoadingArticle &&
                !isLoadingSite &&
                !isLoadingCurrent &&
                !isLoadingOld &&
                !isLoadingCurrentAmp &&
                !isLoadingOldAmp &&
                article &&
                data &&
                data.length === 0 &&
                'no data') ||
                null}
            {(!isLoadingArticle &&
                !isLoadingSite &&
                !isLoadingCurrent &&
                !isLoadingOld &&
                !isLoadingCurrentAmp &&
                !isLoadingOldAmp &&
                article &&
                data.length && (
                    <React.Fragment>
                        <DateRangePicker onChange={setDate} value={date} className="float-right" locale="fr" />
                        <h2>{article.title}</h2>
                        <p>{article.permalink}</p>
                        {(data && (
                            <Chart
                                data={data.sort(byDate).reduce((acc, item) => {
                                    acc.push({ name: item.keys[1], clicks: item.clicks, impressions: item.impressions })
                                    return acc
                                }, [])}
                            />
                        )) ||
                            null}
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>page</th>
                                    <th>impressions</th>
                                    <th>clicks</th>
                                    <th>date</th>
                                    <th>position</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data &&
                                    data.map((r, index) => (
                                        <tr key={`r-${index}`}>
                                            <td>{r.keys[0]}</td>
                                            <td>{r.impressions}</td>
                                            <td>{r.clicks}</td>
                                            <td>{r.keys[1]}</td>
                                            <td>{r.position.toFixed(2)}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </React.Fragment>
                )) ||
                null}
        </React.Fragment>
    )
}

export default SearchConsole
